import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import PublicLayout from "@/components/PublicLayout";
import DashboardLayout from "@/components/DashboardLayout";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Cycles from "@/pages/Cycles";
import Admissions from "@/pages/Admissions";
import News from "@/pages/News";
import Contact from "@/pages/Contact";
import Gallery from "@/pages/Gallery";
import HonorRoll from "@/pages/HonorRoll";
import Agrements from "@/pages/Agrements";
import Demo from "@/pages/Demo";
import Login from "@/pages/Login";
import AdminPortal from "@/pages/AdminPortal";

import DashboardHome from "@/pages/dashboard/DashboardHome";
import ChildrenPage from "@/pages/dashboard/ChildrenPage";
import GradesPage from "@/pages/dashboard/GradesPage";
import GradesEntryPage from "@/pages/dashboard/GradesEntryPage";
import AttendancePage from "@/pages/dashboard/AttendancePage";
import RankingsPage from "@/pages/dashboard/RankingsPage";
import PaymentsPage from "@/pages/dashboard/PaymentsPage";
import AIPage from "@/pages/dashboard/AIPage";
import BooksPage from "@/pages/dashboard/BooksPage";
import OrdersPage from "@/pages/dashboard/OrdersPage";
import StockPage from "@/pages/dashboard/StockPage";
import ComplaintsPage from "@/pages/dashboard/ComplaintsPage";
import AnnouncementsPage from "@/pages/dashboard/AnnouncementsPage";
import MessagesPage from "@/pages/dashboard/MessagesPage";
import UsersPage from "@/pages/dashboard/UsersPage";
import HonorRollAdminPage from "@/pages/dashboard/HonorRollAdminPage";
import SiteContentPage from "@/pages/dashboard/SiteContentPage";
import AdminDashboard from "@/pages/dashboard/AdminDashboard";
import FinanceDashboard from "@/pages/dashboard/FinanceDashboard";
import ComptabiliteDashboard from "@/pages/dashboard/ComptabiliteDashboard";
import SaisiesPage from "@/pages/dashboard/SaisiesPage";
import JournauxPage from "@/pages/dashboard/JournauxPage";
import BalancePage from "@/pages/dashboard/BalancePage";
import ExploitationPage from "@/pages/dashboard/ExploitationPage";
import TresoreriePage from "@/pages/dashboard/TresoreriePage";
import PlanComptablePage from "@/pages/dashboard/PlanComptablePage";
import InfirmerieDashboard from "@/pages/dashboard/InfirmerieDashboard";
import InfirmeriePassagesPage from "@/pages/dashboard/InfirmeriePassagesPage";
import InfirmerieFichesPage from "@/pages/dashboard/InfirmerieFichesPage";
import PharmaciePage from "@/pages/dashboard/PharmaciePage";
import CantinePage from "@/pages/dashboard/CantinePage";
import Recrutement from "@/pages/Recrutement";
import CandidaturesPage from "@/pages/dashboard/CandidaturesPage";
import PaieDashboard from "@/pages/dashboard/PaieDashboard";
import EmployesPage from "@/pages/dashboard/EmployesPage";
import { PaieRunsListPage, PaieRunDetailPage } from "@/pages/dashboard/PaieRunsPage";
import InscriptionEleve from "@/pages/InscriptionEleve";
import MonEspaceEleve from "@/pages/dashboard/MonEspaceEleve";
import CoursLMSPage from "@/pages/dashboard/CoursLMSPage";
import DevoirsPage from "@/pages/dashboard/DevoirsPage";
import BIDashboard from "@/pages/dashboard/BIDashboard";
import IAPedagogiePage from "@/pages/dashboard/IAPedagogiePage";
import AuditLogPage from "@/pages/dashboard/AuditLogPage";

// Sprint E — ERP Extension
import EvaluationsSubmitPage from "@/pages/dashboard/EvaluationsSubmitPage";
import EvaluationsAdminPage from "@/pages/dashboard/EvaluationsAdminPage";
import SignalementSubmitPage from "@/pages/dashboard/SignalementSubmitPage";
import SignalementAdminPage from "@/pages/dashboard/SignalementAdminPage";
import PointageMePage from "@/pages/dashboard/PointageMePage";
import AbsencesAdminPage from "@/pages/dashboard/AbsencesAdminPage";
import ParentReceiptsPage from "@/pages/dashboard/ParentReceiptsPage";
import ReceiptsValidationPage from "@/pages/dashboard/ReceiptsValidationPage";

// Sprint F — Boucle RH & Pédagogique
import PromotionsPage from "@/pages/dashboard/PromotionsPage";
import IAInactivityPage from "@/pages/dashboard/IAInactivityPage";
import PayrollFromPointagePage from "@/pages/dashboard/PayrollFromPointagePage";
import TeacherAssignmentsPage from "@/pages/dashboard/TeacherAssignmentsPage";
import TeacherStudentsPage from "@/pages/dashboard/TeacherStudentsPage";
import ClassGradesPage from "@/pages/dashboard/ClassGradesPage";
import GradeAdjustmentsPage from "@/pages/dashboard/GradeAdjustmentsPage";
import PedagogySettingsPage from "@/pages/dashboard/PedagogySettingsPage";
import PostesPage from "@/pages/dashboard/PostesPage";
import OrganigrammePage from "@/pages/dashboard/OrganigrammePage";
import ExpensesPage from "@/pages/dashboard/ExpensesPage";
import ProductionResetPage from "@/pages/dashboard/ProductionResetPage";

// Scolarité + Manuel
import ScolariteDashboard from "@/pages/dashboard/ScolariteDashboard";
import ScolariteInscriptionsPage from "@/pages/dashboard/ScolariteInscriptionsPage";
import DossiersElevesPage from "@/pages/dashboard/DossiersElevesPage";
import EmploiDuTempsPage from "@/pages/dashboard/EmploiDuTempsPage";
import QuizElevePage from "@/pages/dashboard/QuizElevePage";
import FeeConfigsPage from "@/pages/dashboard/FeeConfigsPage";
import PaymentPlansPage from "@/pages/dashboard/PaymentPlansPage";
import DiscountsPage from "@/pages/dashboard/DiscountsPage";
import CashierPage from "@/pages/dashboard/CashierPage";

// École config + Manuel utilisateur PDF
import SchoolSettingsPage from "@/pages/dashboard/SchoolSettingsPage";
import UserManualPage from "@/pages/dashboard/UserManualPage";
import CardsPage from "@/pages/dashboard/CardsPage";
import PortailScanPage from "@/pages/dashboard/PortailScanPage";
import KiosquePage from "@/pages/KiosquePage";
import PointageStatsPage from "@/pages/dashboard/PointageStatsPage";
import RegistreInscritsPage from "@/pages/dashboard/RegistreInscritsPage";
import EntreesSortiesPage from "@/pages/dashboard/EntreesSortiesPage";
import PresenceLivePage from "@/pages/dashboard/PresenceLivePage";
import CorrectionsPage from "@/pages/dashboard/CorrectionsPage";
import BibliothequePage from "@/pages/dashboard/BibliothequePage";
import SauvegardesPage from "@/pages/dashboard/SauvegardesPage";
import EtatsServicePage from "@/pages/dashboard/EtatsServicePage";
import CoinLecturePage from "@/pages/dashboard/CoinLecturePage";
import InstallAppPage from "@/pages/dashboard/InstallAppPage";
import OuvertureAnneePage from "@/pages/dashboard/OuvertureAnneePage";
import { OfflineBanner } from "@/components/OfflineBanner";
import GoogleAuthCallback from "@/components/GoogleAuthCallback";

// Détection SYNCHRONE du retour Google OAuth (fragment #session_id=...) AVANT les routes.
// Doit lire useLocation().hash (réactif), pas window.location.hash.
function GoogleAuthGate({ children }) {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <GoogleAuthCallback />;
  return children;
}

// Bascule le manifeste PWA selon la zone : portail connecté vs site public.
// Permet d'installer "Mazid Portail" (ouvre /dashboard) depuis les pages du portail.
const PORTAL_PREFIXES = ["/dashboard", "/admin-portal", "/connexion", "/login", "/inscription-eleve"];
function ManifestSwitcher() {
  const { pathname } = useLocation();
  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]');
    if (!link) return;
    const isPortal = PORTAL_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));
    const target = isPortal ? "/manifest-portal.json" : "/manifest.json";
    if (!link.getAttribute("href").endsWith(target)) link.setAttribute("href", target);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ManifestSwitcher />
        <OfflineBanner />
        <Toaster position="top-right" richColors />
        <PWAInstallPrompt />
        <GoogleAuthGate>
        <Routes>
          {/* Public */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/cycles" element={<Cycles />} />
            <Route path="/admissions" element={<Admissions />} />
            <Route path="/inscription" element={<Admissions />} />
            <Route path="/actualites" element={<News />} />
            <Route path="/galerie" element={<Gallery />} />
            <Route path="/tableau-honneur" element={<HonorRoll />} />
            <Route path="/agrements" element={<Agrements />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/recrutement" element={<Recrutement />} />
            <Route path="/inscription-eleve" element={<InscriptionEleve />} />
          </Route>

          {/* Auth (no layout) */}
          <Route path="/connexion" element={<Login />} />
          <Route path="/login" element={<Login />} />
          {/* Lien admin discret — non listé dans la navigation publique */}
          <Route path="/admin-portal" element={<AdminPortal />} />
          {/* Mode kiosque plein écran pour la tablette du portier */}
          <Route path="/kiosque-portail" element={<KiosquePage />} />

          {/* Dashboard */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<DashboardHome />} />
            <Route path="enfants" element={<ChildrenPage />} />
            <Route path="notes" element={<GradesPage />} />
            <Route path="paiements" element={<PaymentsPage />} />
            <Route path="finance" element={<FinanceDashboard />} />
            <Route path="inscriptions" element={<AdminDashboard />} />
            <Route path="eleves" element={<ChildrenPage />} />
            <Route path="annonces" element={<AnnouncementsPage />} />
            <Route path="reclamations" element={<ComplaintsPage />} />
            <Route path="manuels" element={<BooksPage />} />
            <Route path="commandes" element={<OrdersPage />} />
            <Route path="stock" element={<StockPage />} />
            <Route path="saisie-notes" element={<GradesEntryPage />} />
            <Route path="presences" element={<AttendancePage />} />
            <Route path="classements" element={<RankingsPage />} />
            <Route path="messages" element={<MessagesPage />} />
            <Route path="utilisateurs" element={<UsersPage />} />
            <Route path="tableau-honneur" element={<HonorRollAdminPage />} />
            <Route path="contenu-site" element={<SiteContentPage />} />
            <Route path="ai" element={<AIPage />} />
            {/* Module Comptabilité — SYSCOHADA */}
            <Route path="comptabilite" element={<ComptabiliteDashboard />} />
            <Route path="comptabilite/saisies" element={<SaisiesPage />} />
            <Route path="comptabilite/journaux" element={<JournauxPage />} />
            <Route path="comptabilite/balance" element={<BalancePage />} />
            <Route path="comptabilite/exploitation" element={<ExploitationPage />} />
            <Route path="comptabilite/tresorerie" element={<TresoreriePage />} />
            <Route path="comptabilite/plan-comptable" element={<PlanComptablePage />} />
            {/* Module Infirmerie */}
            <Route path="infirmerie" element={<InfirmerieDashboard />} />
            <Route path="infirmerie/passages" element={<InfirmeriePassagesPage />} />
            <Route path="infirmerie/fiches" element={<InfirmerieFichesPage />} />
            <Route path="infirmerie/pharmacie" element={<PharmaciePage />} />
            {/* Module Cantine */}
            <Route path="cantine" element={<CantinePage />} />
            {/* Sprint A — Recrutement RH */}
            <Route path="rh/candidatures" element={<CandidaturesPage />} />
            {/* Sprint A — Paie */}
            <Route path="paie" element={<PaieDashboard />} />
            <Route path="paie/employes" element={<EmployesPage />} />
            <Route path="paie/runs" element={<PaieRunsListPage />} />
            <Route path="paie/runs/:runId" element={<PaieRunDetailPage />} />
            {/* Sprint B — Portail Élève & LMS */}
            <Route path="mon-espace" element={<MonEspaceEleve />} />
            <Route path="cours" element={<CoursLMSPage />} />
            <Route path="devoirs" element={<DevoirsPage />} />
            {/* Sprint C+D — BI, IA, Audit */}
            <Route path="bi" element={<BIDashboard />} />
            <Route path="ia-pedagogique" element={<IAPedagogiePage />} />
            <Route path="audit" element={<AuditLogPage />} />
            {/* Sprint E — ERP Extension */}
            <Route path="evaluer-enseignants" element={<EvaluationsSubmitPage />} />
            <Route path="evaluations" element={<EvaluationsAdminPage />} />
            <Route path="signaler" element={<SignalementSubmitPage />} />
            <Route path="signalements" element={<SignalementAdminPage />} />
            <Route path="pointage" element={<PointageMePage />} />
            <Route path="absences" element={<AbsencesAdminPage />} />
            <Route path="mes-recus" element={<ParentReceiptsPage />} />
            <Route path="validation-recus" element={<ReceiptsValidationPage />} />
            {/* Sprint F — Boucle RH & Pédagogique */}
            <Route path="promotions" element={<PromotionsPage />} />
            <Route path="ia-inactivite" element={<IAInactivityPage />} />
            <Route path="affectations" element={<TeacherAssignmentsPage />} />
            <Route path="mes-eleves" element={<TeacherStudentsPage />} />
            <Route path="notes-classe" element={<ClassGradesPage />} />
            <Route path="reajustements" element={<GradeAdjustmentsPage />} />
            <Route path="parametres-pedagogiques" element={<PedagogySettingsPage />} />
            <Route path="postes" element={<PostesPage />} />
            <Route path="organigramme" element={<OrganigrammePage />} />
            <Route path="depenses" element={<ExpensesPage />} />
            <Route path="paie/auto-pointage" element={<PayrollFromPointagePage />} />
            <Route path="production-reset" element={<ProductionResetPage />} />
            {/* Scolarité — Sprint G */}
            <Route path="scolarite" element={<ScolariteDashboard />} />
            <Route path="scolarite/inscriptions" element={<ScolariteInscriptionsPage />} />
            <Route path="scolarite/dossiers" element={<DossiersElevesPage />} />
            <Route path="emploi-du-temps" element={<EmploiDuTempsPage />} />
            <Route path="quiz-ia" element={<QuizElevePage />} />
            <Route path="scolarite/frais" element={<FeeConfigsPage />} />
            <Route path="scolarite/plans" element={<PaymentPlansPage />} />
            <Route path="scolarite/remises" element={<DiscountsPage />} />
            <Route path="scolarite/encaisser" element={<CashierPage />} />
            {/* Scolarité, école, manuel */}
            <Route path="ecole/parametres" element={<SchoolSettingsPage />} />
            <Route path="parametres-ecole" element={<SchoolSettingsPage />} />
            <Route path="manuel" element={<UserManualPage />} />
            <Route path="cartes" element={<CardsPage />} />
            <Route path="portail" element={<PortailScanPage />} />
            <Route path="pointages-stats" element={<PointageStatsPage />} />
            <Route path="registre-inscrits" element={<RegistreInscritsPage />} />
            <Route path="entrees-sorties" element={<EntreesSortiesPage />} />
            <Route path="presence" element={<PresenceLivePage />} />
            <Route path="corrections" element={<CorrectionsPage />} />
            <Route path="bibliotheque" element={<BibliothequePage />} />
            <Route path="sauvegardes" element={<SauvegardesPage />} />
            <Route path="etats-service" element={<EtatsServicePage />} />
            <Route path="coin-lecture" element={<CoinLecturePage />} />
            <Route path="installer" element={<InstallAppPage />} />
            <Route path="ouverture-annee" element={<OuvertureAnneePage />} />
          </Route>
        </Routes>
        </GoogleAuthGate>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
